import React, { useState, useEffect } from "react";
import { Button, Grid } from "@material-ui/core";
import PageHeader from "../../Components/PageHeader";
import Services from '../../Services';
import PageLayout from "../../Components/LayoutComponents/PageLayout";
import { DatePicker, Form, Input, Select, Table } from "antd";
import DynamicTable from "../../Components/TableComponents/DynamicTable";
import TankReadingModal from "./TankReading.modal";
import TankEventModal from "./TankEvent.modal";
import { calculate_gallons_amt, calculate_gallons_amt_fuel_management, fuel_tank_master, fuel_tank_master_unique, get_fuel_tank_events } from "../../Services/fuel management";
import moment from "moment";
import useDebounce from "./useDebounce";
import { EditOutlined } from "@ant-design/icons";
import { seriliazeParams } from "../../helpers/seriliazeParams";

const { } = Services;

const FuelManagement = ({ currentTab }) => {

    const [events, setEvents] = useState([]);
    const [mode, setMode] = useState(null)
    const [relaoder, setRelaoder] = useState(false);
    const [totalFigures, setTotalFigures] = useState({
        gallons: 0,
        amount: 0
    })
    const [dropdowns, setDropdowns] = useState({
        fuel_tank_master: []
    })
    const [filters, setFilters] = useState({
        bill_of_lading: "",
        invoice_nbr: "",
        FuelTkID: null,
        start_date: null,
        end_date: null,
        vender: null,
        invoice: null
    });
    console.log({ filters })
    const [modalsOpen, setModalsOpen] = useState({
        tank_event: false,
        tank_reading: false
    });

    const debouncedBillOfLading = useDebounce(filters.bill_of_lading, 1000); // Debounce for 1 second
    const debouncedInvoiceNbr = useDebounce(filters.invoice_nbr, 1000); // Debounce for 1 second

    const show_gross_ppg = (invoice_total, gallons_added) => {
        let gross_ppg = invoice_total / gallons_added;
        if ([undefined, 0, "", "0", NaN, Infinity]?.includes(gross_ppg)) return '0'
        else return gross_ppg % 1 === 0 ? gross_ppg : gross_ppg.toFixed(3)
    }

    function removeDuplicateObjects(arr) {
        const uniqueObjects = [];
        const seenObjects = new Set();
        for (const obj of arr) {
            const objString = JSON.stringify(obj);
            if (!seenObjects.has(objString)) {
                seenObjects.add(objString);
                uniqueObjects.push(obj);
            }
        }

        return uniqueObjects;
    }

    let columns = [
        {
            title: "Fill Date",
            render: (_, record) => {
                return <div>{record?.FillDate ? moment(record?.FillDate)?.utc()?.format("MM-DD-YYYY") : "N/A"}</div>
            },
        },
        {
            title: "Gallons",
            render: (_, record) => {
                return <div>{record?.Gallons ? record?.Gallons?.toLocaleString() : "N/A"}</div>
            }
        },
        {
            title: "Vendor / PO No.",
            render: (_, record) => {
                return <div>{`${record?.ContractorMaster?.Company} / ${record?.PO}`}</div>
            },
            filters: removeDuplicateObjects(events?.map(x => ({ text: `${x?.ContractorMaster?.Company} / ${x?.PO}`, value: `${x?.ContractorMaster?.Company} / ${x?.PO}` }))),
            filterSearch: true,
            onFilter: (value, record) =>
                `${record?.ContractorMaster?.Company} / ${record?.PO}`.toLowerCase() === value.toLowerCase()
        },
        {
            title: "Invoice No.",
            render: (_, record) => {
                return <div>{record?.InvNbr || "N/A"}</div>
            },
            filters: removeDuplicateObjects(events?.filter(x => x?.InvNbr)?.map(x => ({ text: x?.InvNbr, value: x?.InvNbr }))),
            filterSearch: true,
            onFilter: (value, record) =>
                record?.InvNbr === value.toLowerCase()
        },
        {
            title: "Gross PPG",
            render: (_, record) => {
                return <div>{show_gross_ppg(record?.InvTotalAmt, record?.Gallons)}</div>
            }
        },
        {
            title: "Inv Amt",
            render: (_, record) => {
                return <div>{record?.InvTotalAmt ? `$ ${record?.InvTotalAmt.toLocaleString()}` : "N/A"}</div>
            }
        },
        {
            render: (_, record) => {
                return <div>
                    <span className="EditIcon" style={{ cursor: "pointer" }} onClick={() => {
                        setMode(record?.id)
                        setModalsOpen(prev => ({ ...prev, tank_event: true }));
                    }} />
                </div>
            }
        }
    ]


    const fetchFuelTank = async () => {
        let response = await fuel_tank_master_unique()
        if (response?.httpStatus === 200) {
            setDropdowns(prev => { return { ...prev, fuel_tank_master: response?.data?.map(x => { return { value: x?.SrvcGalType, label: x?.SrvcGalType } }) } })
            setFilters(prev => { return { ...prev, FuelTkID: response?.data[1]?.SrvcGalType } })
        }
    }

    const calculateGallons = async () => {
        let obj = {
            SrvcGalType: filters?.FuelTkID,
            start_date: filters?.start_date?.format("YYYY-MM-DD"),
            end_date: filters?.end_date?.format("YYYY-MM-DD"),
            BOL: debouncedBillOfLading,
            InvNbr: debouncedInvoiceNbr
        }
        let filterKeys = Object.fromEntries(
            Object.entries(obj).filter(
                ([_, value]) => value !== undefined && value !== null && value !== ""
            )
        );
        let params = '?'.concat(seriliazeParams(filterKeys))
        let response = await calculate_gallons_amt_fuel_management(params)
        console.log({response})
        if (response?.httpStatus === 200) {
            setTotalFigures({ amount: response?.data?.total_amount, gallons: response?.data?.total_gallons })
            setEvents(response?.data?.FuelFills)
        }
    }

    useEffect(() => {
        fetchFuelTank()
        setFilters(prev => {
            return {
                ...prev,
                start_date: moment().startOf('month'),
                end_date: moment(),
            }
        })
    }, [])


    useEffect(() => {
        calculateGallons()
    }, [filters?.FuelTkID, filters?.start_date, filters?.end_date, relaoder, debouncedBillOfLading, debouncedInvoiceNbr])

    return (

        <div style={{ display: "flex", flexDirection: "column", gap: "50px", margin: "20px 0" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <button
                    onClick={() => {
                        setModalsOpen(prev => ({ ...prev, tank_event: true }));
                        setMode(null)
                    }}
                    className="LinkButton">
                    Add Tank Fill Event
                </button>
                <button
                    onClick={() => {
                        setModalsOpen(prev => ({ ...prev, tank_reading: true }));
                    }}
                    className="LinkButton">
                    Add Tank Reading
                </button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <span style={{ fontSize: "20px", fontWeight: "600" }}>Recent Tank Refueling</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "20px", justifyContent: "space-between", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "flex-end", gap: "20px", justifyContent: "flex-start", flexWrap: "wrap" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                {/* <span className="label">{"Recent tank refueling"}</span> */}
                                <Select
                                    placeholder="Select"
                                    value={filters.FuelTkID}
                                    style={{ width: "150px" }}
                                    onChange={e => setFilters(prev => ({ ...prev, FuelTkID: e }))}
                                    options={dropdowns?.fuel_tank_master}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span className="label">{"Start date"}</span>
                                <DatePicker
                                    placeholder="Select start date"
                                    value={filters.start_date}
                                    allowClear={false}
                                    format="MM-DD-YYYY"
                                    disabledDate={(current) => {
                                        return current && current > moment().endOf("day");
                                    }}
                                    style={{ width: "150px" }}
                                    onChange={e => setFilters(prev => ({ ...prev, start_date: e, end_date: prev.end_date && e && e?.isAfter(prev.end_date, "day") ? null : prev.end_date }))}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span className="label">{"End date"}</span>
                                <DatePicker
                                    placeholder="Select end date"
                                    value={filters.end_date}
                                    format="MM-DD-YYYY"
                                    disabledDate={(current) => {
                                        const today = moment().endOf('day');
                                        const startDate = filters?.start_date;
                                        return (
                                            (startDate && current && current.isBefore(startDate, 'day')) ||
                                            (current && current.isAfter(today))
                                        );
                                    }}
                                    allowClear={false}
                                    style={{ width: "150px" }}
                                    onChange={e => setFilters(prev => ({ ...prev, end_date: e }))}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "3px", position: "relative" }}>
                                <div style={{}}><strong>Total Gallons: </strong>{totalFigures?.gallons}</div>
                                <div style={{}}><strong>Total Amt: </strong>${totalFigures?.amount?.toLocaleString()}</div>
                                <div>
                                    <button
                                        style={{ position: "absolute", top: "-40px", right: 0, background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "60px", height: "30px", cursor: "pointer", fontSize: "10px" }}
                                        onClick={() => {
                                            setFilters(prev => ({ ...prev, FuelTkID: dropdowns?.fuel_tank_master[1]?.value,
                                                bill_of_lading:'',
                                                invoice_nbr:'',
                                                start_date: moment().startOf('month'), end_date: moment() }))
                                        }}>
                                        Reset
                                    </button>
                                </div>
                            </div>


                        </div>
                        <div style={{ display: "flex", alignItems: "flex-end", gap: "20px", justifyContent: "flex-end", flexWrap: "wrap" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span className="label">{"Bill of lading"}</span>
                                <Input
                                    value={filters.bill_of_lading}
                                    style={{ width: "150px" }}
                                    onChange={e => setFilters(prev => ({ ...prev, bill_of_lading: e.target.value }))}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span className="label">{"Invoice Nbr"}</span>
                                <Input
                                    value={filters.invoice_nbr}
                                    style={{ width: "150px" }}
                                    onChange={e => setFilters(prev => ({ ...prev, invoice_nbr: e.target.value }))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Table
                // locale={{ filterReset: "" }}
                pagination={
                    {
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "25", "30", '50', '100'],
                        showSizeChanger: true,
                        defaultCurrent: 1,
                    }
                }
                columns={columns}
                dataSource={events}
                // onChange={handleChange}

                scroll={{ x: 400 }}
                size="middle"
                style={{ fontSize: "10px" }}
            />
            {/* <DynamicTable tableData={tableData} Pagination={events.length > 10} /> */}
            <TankEventModal mode={mode} setRelaoder={setRelaoder} open={modalsOpen.tank_event} close={() => setModalsOpen(prev => ({ ...prev, tank_event: false }))} />
            <TankReadingModal setRelaoder={setRelaoder} open={modalsOpen.tank_reading} close={() => setModalsOpen(prev => ({ ...prev, tank_reading: false }))} />
        </div>

    );
};

export default FuelManagement;